<template>
  <div class="token-body">
    <div class="token-table">
      <div class="table-title">代币详情</div>
      <div class="table-body">
        <div class="table-left">
          <div class="basicInfo">
            <div class="basicInfo-title">基本信息</div>
            <div class="basicInfo-content">
              <div class="content">
                <div class="label">全称</div>
                <div class="text">{{ this.contentData.name }}</div>
                <div class="label">简称</div>
                <div class="text">{{ this.contentData.symbol }}</div>
              </div>
              <div class="content">
                <div class="label">精度</div>
                <div class="text">18</div>
                <div class="label">总量</div>
                <div class="text">{{ contentData.total }}</div>
              </div>
              <div class="content">
                <div class="label">代币模板</div>
                <div class="text">
                  {{ template | getNameWithMode }}
                </div>
 
                <div class="label">所有者</div>
                <div class="text" v-if="template == 'base'||template == 'freeMint'">无</div>
                <div class="text" v-else>
                  {{ contentData.owner | addressEll
                  }}<i
                    v-if="contentData.owner"
                    class="el-icon-document-copy"
                    @click="copyText($event, contentData.owner)"
                  ></i>
                </div>
                
              </div>
              <div class="content">
                <div class="label">合约地址</div>
                <div class="text flex-row">
                  <div>
                    {{ tokenDetailData.contractAddress | addressEll
                    }}<i
                      class="el-icon-document-copy"
                      @click="copyText($event, tokenDetailData.contractAddress)"
                    ></i>
                  </div>
                  <div style="margin-left: 10px; cursor: pointer">
                    <i class="el-icon-top-right" @click="openExplore"></i>
                  </div>
                </div>
                <div :class="[template == 'freeMint' ? 'label' : 'text']">
                  {{ template == "freeMint" ? "单账户铸造数量" : "" }}
                </div>
                <div class="text">
                  {{ template == "freeMint" ? mintAmount : "" }}
                </div>
              </div>
            </div>
          </div>

          <div class="economicModel">
            <div class="basicInfo-title">经济模型</div>
            <div
              class="basicInfo-content"
              v-if="template != 'base' && template != 'freeMint'"
            >
              <div class="content">
                <div class="label2">交易所</div>
                <div class="text2">
                  {{ contentData.swapPlatform | getNameWithSwapAddress }}（
                  {{ contentData.swapPlatform | addressEll }} ）<i
                    class="el-icon-document-copy"
                    @click="copyText($event, contentData.swapPlatform)"
                  ></i>
                </div>
              </div>
              <div class="content" v v-if="contentData.currency">
                <div class="label2">底池代币</div>
                <div class="text2">
                  {{ contentData.currency | getNameWithCurrencyAddress }}（
                  {{ contentData.currency | addressEll }} ）<i
                    class="el-icon-document-copy"
                    @click="copyText($event, contentData.currency)"
                  ></i>
                </div>
              </div>
              <div class="content" v-if="contentData.rewardToken">
                <div class="label2">分红代币</div>
                <div class="text2">
                  {{ contentData.rewardToken | getNameWithCurrencyAddress }}（
                  {{ contentData.rewardToken | addressEll }} ）<i
                    class="el-icon-document-copy"
                    @click="copyText($event, contentData.rewardToken)"
                  ></i>
                </div>
              </div>
              <div class="content">
                <div class="label2">买入税率</div>
                <div class="text2">
                  {{ buyTaxRate }}% ( 营销 {{ contentData.buyFundFee || 0 }}% +
                  销毁 {{ contentData.buyBurnFee || 0 }}% + 分红
                  {{ contentData.buyLPFee || 0 }}% + 回流
                  {{ contentData.buyRewardFee || 0 }}% )
                </div>
              </div>
              <div class="content">
                <div class="label2">卖出税率</div>
                <div class="text2">
                  {{ sellTaxRate }}% ( 营销 {{ contentData.sellFundFee || 0 }}%
                  + 销毁 {{ contentData.sellBurnFee || 0 }}% + 分红
                  {{ contentData.sellLPFee || 0 }}% + 回流
                  {{ contentData.sellRewardFee || 0 }}% )
                </div>
              </div>
              <div class="content" v-if="contentData.inviterFee">
                <div class="label2">推荐税率</div>
                <div class="text2">{{ contentData.inviterFee }}%</div>
              </div>
              <div class="content" v-if="contentData.generations">
                <div class="label2">推荐奖励</div>
                <div class="text2">
                  {{ contentData.generations }}代奖励：( 一代奖励
                  {{ contentData.firstRate || 0 }}%；二代奖励
                  {{ contentData.secondRate || 0 }}%；三代奖励
                  {{ contentData.thirdRate || 0 }}%；其余各代奖励
                  {{ contentData.leftRate || 0 }}%)
                </div>
              </div>
              <div class="content" v-if="template == 'lpDividend'">
                <div class="label2">加池税率</div>
                <div class="text2">{{ contentData.addLiquidityFee }}%</div>
              </div>
              <div
                class="content"
                v-if="template != 'base' && template != 'dividend'"
              >
                <div class="label2">撤池税率</div>
                <div class="text2">{{ contentData.removeLiquidityFee }}%</div>
              </div>

              <div class="content">
                <div class="label2">营销钱包</div>
                <div class="text2">
                  {{ contentData.fundAddress | addressEll
                  }}<i
                    class="el-icon-document-copy"
                    @click="copyText($event, contentData.fundAddress)"
                  ></i>
                </div>
              </div>
              <div
                class="content"
                v-if="contentData.hasOwnProperty('enableKillBlock')"
              >
                <div class="label2">杀抢跑机器人区块</div>
                <div class="text2">
                  {{ contentData.kb || "无" }}
                </div>
              </div>
              <div
                class="content"
                v-if="contentData.hasOwnProperty('enableWalletLimit')"
              >
                <div class="label2">单钱包持币上限</div>
                <div class="text2">
                  {{ this.tokenDetailData.maxWalletAmount || "无" }}
                </div>
              </div>
              <div
                class="content"
                v-if="contentData.hasOwnProperty('airdropEnable')"
              >
                <div class="label2">交易空投地址数</div>
                <div class="text2">
                  {{ contentData.airdropNumbs || "无" }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="table-right"
          v-if="
            template != 'base' &&
            template != 'freeMint' &&
            template != 'dividend' &&
            tokenDetailData.status == 2 &&
            contentData.owner == account
          "
        >
          <div class="permissionControl">
            <div class="basicInfo-title">权限控制</div>
            <div class="basicInfo-content">
              <div class="flex-row">
                <el-button
                  class="btn"
                  @click="
                    dialogInfo = infoList[0][0];
                    dialogVisible = true;
                  "
                >
                  转让所有权</el-button
                >
                <el-button class="btn" @click="renounceOwnership()"
                  >丢弃权限</el-button
                >
              </div>
            </div>
          </div>

          <div class="liquidityControl">
            <div class="basicInfo-title">流动性控制</div>
            <div class="basicInfo-content">
              <div class="flex-row">
                <el-button
                  class="btn"
                  v-if="template == 'lpDividend'"
                  @click="
                    dialogInfo = infoList[1][0];
                    dialogVisible = true;
                  "
                  >设置加池税率</el-button
                >
                <el-button
                  class="btn"
                  @click="
                    dialogInfo = infoList[1][1];
                    dialogVisible = true;
                  "
                  >设置撤池税率</el-button
                >
              </div>
            </div>
          </div>

          <div class="transactionControl">
            <div class="basicInfo-title">交易控制</div>
            <div class="basicInfo-content">
              <el-button class="btn" :disabled="!contentData.enableOffTrade"
                >开启交易</el-button
              >
              <div
                class="flex-row"
                v-if="contentData.hasOwnProperty('enableWalletLimit')"
              >
                <el-button
                  class="btn"
                  :disabled="!contentData.enableWalletLimit"
                  @click="
                    dialogInfo = infoList[2][0];
                    dialogVisible = true;
                  "
                  >修改持币上限</el-button
                >
                <el-button
                  class="btn"
                  @click="disableWalletLimit()"
                  :disabled="!contentData.enableWalletLimit"
                  >关闭持币限制</el-button
                >
              </div>
              <div class="flex-row" v-if="template == 'lpDividend'">
                <el-button
                  class="btn"
                  :disabled="!contentData.enableWalletLimit"
                  @click="
                    dialogInfo = infoList[2][1];
                    dialogVisible = true;
                  "
                  >添加持币白名单</el-button
                >
                <el-button
                  class="btn"
                  :disabled="!contentData.enableWalletLimit"
                  @click="
                    dialogInfo = infoList[2][2];
                    dialogVisible = true;
                  "
                  >删除持币白名单</el-button
                >
              </div>
              <div class="flex-row">
                <el-button
                  class="btn"
                  :disabled="!contentData.enableRewardList"
                  @click="
                    dialogInfo = infoList[2][3];
                    dialogVisible = true;
                  "
                  >添加黑名单</el-button
                >
                <el-button
                  class="btn"
                  :disabled="!contentData.enableRewardList"
                  @click="
                    dialogInfo = infoList[2][4];
                    dialogVisible = true;
                  "
                  >删除黑名单</el-button
                >
              </div>
              <el-button
                class="btn"
                :disabled="!contentData.airdropEnable"
                @click="
                  dialogInfo = infoList[2][5];
                  dialogVisible = true;
                "
                >杀抢跑机器人</el-button
              >
              <el-button
                class="btn"
                v-if="template == 'lpDividend'"
                @click="
                  dialogInfo = infoList[2][6];
                  dialogVisible = true;
                "
                >设置空投数量</el-button
              >
              <el-button
                class="btn"
                @click="
                  dialogInfo = infoList[2][7];
                  dialogVisible = true;
                "
                >添加交易对</el-button
              >
            </div>
          </div>

          <div class="taxRateControl">
            <div class="basicInfo-title">税率控制</div>
            <div class="basicInfo-content">
              <el-button
                class="btn"
                :disabled="!contentData.enableChangeTax"
                @click="
                  tokenForm = contentData;
                  dialogInfo = infoList[3][0];
                  dialogVisible = true;
                "
                >修改税率</el-button
              >
              <div class="flex-row">
                <el-button
                  class="btn"
                  @click="
                    dialogInfo = infoList[3][1];
                    dialogVisible = true;
                  "
                  >添加税率白名单</el-button
                >
                <el-button
                  class="btn"
                  @click="
                    dialogInfo = infoList[3][2];
                    dialogVisible = true;
                  "
                  >删除税率白名单</el-button
                >
              </div>
              <el-button
                class="btn"
                @click="
                  dialogInfo = infoList[3][3];
                  dialogVisible = true;
                "
                >修改营销钱包</el-button
              >
            </div>
          </div>

          <div class="dividendControl">
            <div class="basicInfo-title">分红控制</div>
            <div class="basicInfo-content">
              <!-- <div class="flex-row">
                  <el-button
                class="btn"
                @click="
                  dialogInfo = infoList[4][0];
                  dialogVisible = true;
                "
                >提取本币</el-button
              >  <el-button
                class="btn"
                @click="
                  dialogInfo = infoList[4][1];
                  dialogVisible = true;
                "
                >提取分红代币</el-button
              >
                </div> -->

              <el-button
                class="btn"
                @click="
                  dialogInfo = infoList[4][2];
                  dialogVisible = true;
                "
                >设置分红黑名单</el-button
              >
              <el-button
                class="btn"
                @click="
                  dialogInfo = infoList[4][3];
                  dialogVisible = true;
                "
                >设置分红阈值</el-button
              >
            </div>
          </div>
          <div class="dividendControl" v-if="template == 'lpWithInviter'">
            <div class="basicInfo-title">推荐奖励控制</div>
            <div class="basicInfo-content">
              <el-button
                class="btn"
                @click="
                  tokenForm = contentData;
                  dialogInfo = infoList[5][0];
                  dialogVisible = true;
                "
                >修改推荐税率</el-button
              >
              <el-button
                class="btn"
                @click="
                  dialogInfo = infoList[5][1];
                  dialogVisible = true;
                "
                >设置推荐奖励比例</el-button
              >
              <el-button
                class="btn"
                @click="
                  dialogInfo = infoList[5][2];
                  dialogVisible = true;
                "
                >设置最小转账金额</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      :title="dialogInfo.dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      top="20vh"
      center
    >
      <div>
        <div style="margin: 10px 0">{{ dialogInfo.dialogText }}</div>
        <div v-if="dialogInfo.tag != 41">
          <el-input v-model="inputText" placeholder="请输入"></el-input>
        </div>
        <div v-else>
          <el-form
            :model="tokenForm"
            ref="ruleForm"
            label-width="100px"
            label-position="top"
            class="token-form"
          >
            <el-form-item label="买入税率:最大25%">
              <div class="token-handlingFees">
                <el-input
                  @keyup.native="onlyNumber()"
                  placeholder="0.01"
                  v-model="tokenForm.buyFundFee"
                >
                  <template slot="prepend">营销税率:</template>
                  <el-button slot="append">%</el-button>
                </el-input>

                <el-input
                  @keyup.native="onlyNumber()"
                  placeholder="0.01"
                  v-model="tokenForm.buyBurnFee"
                >
                  <template slot="prepend">销毁税率:</template>
                  <el-button slot="append">%</el-button>
                </el-input>
              </div>

              <div class="token-handlingFees">
                <el-input
                  @keyup.native="onlyNumber()"
                  placeholder="0.01"
                  v-model="tokenForm.buyRewardFee"
                >
                  <template slot="prepend">回流税率:</template>
                  <el-button slot="append">%</el-button>
                </el-input>

                <el-input
                  @keyup.native="onlyNumber()"
                  placeholder="0.01"
                  v-model="tokenForm.buyLPFee"
                >
                  <template slot="prepend">分红税率:</template>
                  <el-button slot="append">%</el-button>
                </el-input>
                <span class="token-mark"
                  >推荐税率: {{ tokenForm.inviterFee }}%</span
                >
              </div>

              <!-- <span class="token-mark">百分比设置,总比例不可以大于百分之25%</span> -->
            </el-form-item>

            <el-form-item label="卖出税率:最大25%">
              <div class="token-handlingFees">
                <el-input
                  @keyup.native="onlyNumber()"
                  placeholder="0.01"
                  v-model="tokenForm.sellFundFee"
                >
                  <template slot="prepend">营销税率:</template>
                  <el-button slot="append">%</el-button>
                </el-input>

                <el-input
                  @keyup.native="onlyNumber()"
                  placeholder="0.01"
                  v-model="tokenForm.sellBurnFee"
                >
                  <template slot="prepend">销毁税率:</template>
                  <el-button slot="append">%</el-button>
                </el-input>
              </div>

              <div class="">
                <el-input
                  @keyup.native="onlyNumber()"
                  placeholder="0.01"
                  v-model="tokenForm.sellRewardFee"
                >
                  <template slot="prepend">回流税率:</template>
                  <el-button slot="append">%</el-button>
                </el-input>

                <el-input
                  @keyup.native="onlyNumber()"
                  placeholder="0.01"
                  v-model="tokenForm.sellLPFee"
                >
                  <template slot="prepend">分红税率:</template>
                  <el-button slot="append">%</el-button>
                </el-input>
                <span class="token-mark"
                  >推荐税率: {{ tokenForm.inviterFee }}%</span
                >
              </div>

              <!-- <span class="token-mark">买卖营销税之和必须大于0!</span> -->
            </el-form-item>
          </el-form>
        </div>
        <div>{{ dialogInfo.tips }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="setFunction()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { consoleDetail } from "@/config/api.js";
import { LPABI } from "@/config/abi.js";
import Clipboard from "clipboard";
import { ethers } from "ethers";
export default {
  data() {
    return {
      contract: null,
      dialogVisible: false,
      account: localStorage.getItem("TokenBox-account"),
      tokenDetailData: {},
      contentData: {},
      contractId: "",
      template: "",
      inputText: "",
      tokenForm: {},
      dialogInfo: {
        tag: null,
        dialogTitle: "",
        dialogText: "",
        tips: "",
      },
      infoList: [
        [
          {
            tag: 11,
            dialogTitle: "转让所有权",
            dialogText: "转让地址",
            tips: "",
          },
        ],
        [
          {
            tag: 21,
            dialogTitle: "设置加池税率",
            dialogText: "加持税率：最大为25%",
            tips: "",
          },
          {
            tag: 22,
            dialogTitle: "设置撤池税率",
            dialogText: "撤池税率:最大为100%,撤池所得币将销毁",
            tips: "",
          },
        ],
        [
          {
            tag: 31,
            dialogTitle: "修改持币上限",
            dialogText: "持币上限",
            tips: "",
          },
          {
            tag: 32,
            dialogTitle: "添加持币白名单",
            dialogText: "白名单地址",
            tips: "",
          },
          {
            tag: 33,
            dialogTitle: "移除持币白名单",
            dialogText: "白名单地址",
            tips: "",
          },
          {
            tag: 34,
            dialogTitle: "添加持币黑名单",
            dialogText: "白名单地址",
            tips: "",
          },
          {
            tag: 35,
            dialogTitle: "移除持币黑名单",
            dialogText: "白名单地址",
            tips: "",
          },
          {
            tag: 36,
            dialogTitle: "杀开盘抢跑机器人",
            dialogText: "抢跑区块",
            tips: "注:需手动开启交易,开启交易的前X个区块内交易的地址被视为抢跑机器人,自动加入黑名单",
          },
          {
            tag: 37,
            dialogTitle: "设置空投数量",
            dialogText: "空投数量",
            tips: "注:每笔交易均会自动空投给自动生成的地址,最大空投数量为5",
          },
          {
            tag: 38,
            dialogTitle: "添加交易对",
            dialogText: "交易对地址",
            tips: "注:如果您的代币在不同的交易所上架, 或存在不同的交易对, 请将对应的流动池地址添加进来, 否则税率、分红等机制将在其他交易对上不起作用!",
          },
        ],
        [
          {
            tag: 41,
            dialogTitle: "修改税率",
            dialogText: "",
            tips: "",
          },
          {
            tag: 42,
            dialogTitle: "添加税率白名单",
            dialogText: "白名单地址",
            tips: "",
          },
          {
            tag: 43,
            dialogTitle: "移除税率白名单",
            dialogText: "白名单地址",
            tips: "",
          },
          {
            tag: 44,
            dialogTitle: "修改营销钱包",
            dialogText: "营销钱包地址",
            tips: "",
          },
        ],
        [
          {
            tag: 51,
            dialogTitle: "提取合约内本币",
            dialogText: "数量",
            tips: "",
          },
          {
            tag: 52,
            dialogTitle: "提取合约内分红代币",
            dialogText: "分红黑名单地址",
            tips: "该地址将不会收到分红",
          },
          {
            tag: 53,
            dialogTitle: "设置分红黑名单",
            dialogText: "分红黑名单地址",
            tips: "该地址将不会收到分红",
          },
          {
            tag: 54,
            dialogTitle: "设置分红阈值",
            dialogText: "设置分红阈值",
            tips: "当分红钱包内的分红代币数量超过该值时, 开始分红, 默认为0.1个分红代币, 即分红税的价值达到该值是才会开始分红, 设置的过高可能会导致长时间无分红, 强烈建议新用户不要修改此选项 (总结: 分红USDT默认就好, 分红WBNB可适当调低, 例如0.0001, 不要随意调高该值, 引发的任何问题与平台无关)",
          },
        ],
        [
          {
            tag: 61,
            dialogTitle: "修改推荐税率",
            dialogText: "推荐税率",
            tips: "推荐税率买卖相同,需保证买入总税率不能超过25%, 卖出总税率不能超过25%",
          },
          {
            tag: 62,
            dialogTitle: "设置推荐奖励比例",
            dialogText: "",
            tips: "确认前请先核算,确认总比例为100%",
          },
          {
            tag: 63,
            dialogTitle: "设置最小转账金额",
            dialogText: "最小转账金额",
            tips: "用于设定绑定推荐关系的最小转账金额,如希望任意转账金额均可绑定推荐关系,设置0即可\n例:设定最小转账金额为0.1,上级需转账至少0.1给下级,下级至少回转0.1给上级,转账成功即绑定",
          },
        ],
      ],
    };
  },
  async beforeMount() {
    var that = this;
    var queryData = this.$route.query;
    if (queryData.hasOwnProperty("mode")) {
      that.template = queryData.mode;
    }
    if (queryData.hasOwnProperty("contractId")) {
      that.contractId = queryData.contractId;
      await that.requestConsoleDetail();
    }
    if (!window.ethereum) {
      this.$showErrorMessage("当前环境未安装钱包");
    }
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    this.contract = new ethers.Contract(
      this.tokenDetailData.contractAddress,
      LPABI,
      signer
    );
    console.log(this.contract);
    this.requestContractInfo();
  },
  methods: {
    openExplore() {
      var res = this.$getChainConfig(parseInt(this.tokenDetailData.chainId));
      console.log("getChainConfig=", res);
      if (res && res.explore) {
        window.open(res.explore + this.tokenDetailData.contractAddress);
      }
    },
    copyText(e, text) {
      const clipboard = new Clipboard(e.target, {
        text() {
          return text;
        },
      });
      clipboard.on("success", () => {
        this.$message.success("复制成功！");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        console.log("该浏览器不支持自动复制!", "warning", e);
        clipboard.destroy();
      });

      clipboard.onClick(e);
    },
    async requestConsoleDetail() {
      var data = {
        contractId: this.contractId,
      };
      var res = await consoleDetail(data);
      if (res && res.data) {
        this.tokenDetailData.contractAddress = res.data.contractAddress;
        this.tokenDetailData.status = res.data.status;
        if (this.tokenDetailData.status != 2) {
          this.tokenDetailData = res.data;
          this.contentData = {};
          this.contentData = JSON.parse(this.tokenDetailData.content);
          try {
            if (!window.ethereum) {
              this.$showErrorMessage("当前环境未安装钱包");
            }
            const provider = new ethers.providers.Web3Provider(window.ethereum);
            const code = await provider.getCode(
              this.tokenDetailData.contractAddress
            );
            if (code != "0x") {
              this.tokenDetailData.status = 2;
            }
          } catch (error) {
            this.$showErrorMessage(error);
          }
        }
      }
    },

    requestContractInfo() {
     
      if (this.tokenDetailData.status != 2) {
        return;
      }
      this.contract
        .name()
        .then((data) => {
          console.log("name=", data);
          this.$set(this.contentData, "name", data);
        })
        .catch((error) => {
          console.log("获取合约名称错误");
          this.$showErrorMessage(
            "获取合约信息错误，可以尝试断开钱包，重新进行连接"
          );
        });

      this.contract
        .owner()
        .then((data) => {
          console.log("owner=", data, this.account);
          this.$set(this.contentData, "owner", data.toLowerCase());
        })
        .catch((error) => {
          console.log("获取合约拥有者错误");
        });

      this.contract
        .symbol()
        .then((data) => {
          console.log("symbol=", data);
          this.$set(this.contentData, "symbol", data);
        })
        .catch((error) => {
          console.log("获取合约symbol错误");
        });
      this.contract
        .totalSupply()
        .then((data) => {
          console.log("totalSupply=", ethers.utils.formatEther(data));
          this.$set(
            this.contentData,
            "total",
            parseInt(ethers.utils.formatEther(data))
          );
        })
        .catch((error) => {
          console.log("获取合约总量错误");
        });

      this.contract
        .decimals()
        .then((data) => {
          console.log("decimals=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "decimals", data);
        })
        .catch((error) => {
          console.log("获取合约精度错误");
        });
      if (this.template == "base") {
        return;
      }

      if (this.template == "freeMint") {
        this.contract
          .mintAmount()
          .then((data) => {
            console.log("mintAmount=", data);
            // this.contentData.total = data;
            this.$set(
              this.contentData,
              "mintAmount",
              parseInt(ethers.utils.formatEther(data))
            );
          })
          .catch((error) => {
            console.log("获取mintAmount错误");
          });
        return;
      }
      this.contract
        .swapRouter()
        .then((data) => {
          console.log("swapRouter=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "swapPlatform", data);
        })
        .catch((error) => {
          console.log("获取swapRouter错误");
        });

      this.contract
        .currency()
        .then((data) => {
          console.log("currency=", data);
          this.$set(this.contentData, "currency", data);
        })
        .catch((error) => {
          console.log("获取底池代币错误");
        });

      this.contract
        .buyFundFee()
        .then((data) => {
          console.log("buyFundFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "buyFundFee", data * 0.01);
        })
        .catch((error) => {
          console.log("获取buyFundFee税率错误");
        });
      this.contract
        .buyBurnFee()
        .then((data) => {
          console.log("buyBurnFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "buyBurnFee", data * 0.01);
        })
        .catch((error) => {
          console.log("获取buyBurnFee税率错误");
        });
      this.contract
        .buyLPFee()
        .then((data) => {
          console.log("buyLPFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "buyLPFee", data * 0.01);
        })
        .catch((error) => {
          console.log("获取buyLPFee税率错误");
        });
      this.contract
        .buyRewardFee()
        .then((data) => {
          console.log("buyRewardFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "buyRewardFee", data * 0.01);
        })
        .catch((error) => {
          console.log("获取buyRewordFee错误");
        });
      this.contract
        .sellFundFee()
        .then((data) => {
          console.log("sellFundFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "sellFundFee", data * 0.01);
        })
        .catch((error) => {
          console.log("获取sellFundFee错误");
        });
      this.contract
        .sellBurnFee()
        .then((data) => {
          console.log("sellBurnFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "sellBurnFee", data * 0.01);
        })
        .catch((error) => {
          console.log("获取sellBurnFee错误");
        });

      this.contract
        .sellLPFee()
        .then((data) => {
          console.log("_sellLPFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "sellLPFee", data * 0.01);
        })
        .catch((error) => {
          console.log("获取sellLPFee错误");
        });
      this.contract
        .sellRewardFee()
        .then((data) => {
          console.log("sellRewardFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "sellRewardFee", data * 0.01);
        })
        .catch((error) => {
          console.log("获取sellRewardFee错误");
        });
      this.contract
        .fundAddress()
        .then((data) => {
          console.log("fundAddress=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "fundAddress", data);
        })
        .catch((error) => {
          console.log("获取营销钱包错误");
        });
      if (this.template == "dividend") {
        return;
      }
      if (this.template == "lpDividend") {
        this.contract
          .addLiquidityFee()
          .then((data) => {
            console.log("addLiquidityFee=", data);
            // this.contentData.total = data;
            this.$set(this.contentData, "addLiquidityFee", data);
          })
          .catch((error) => {
            console.log("获取加池税率错误");
          });
      }
      if (this.template == "lpWithInviter") {
        this.contract
          ._inviterFee()
          .then((data) => {
            console.log("inviterFee=", data);
            this.$set(this.contentData, "inviterFee", data * 0.01);
          })
          .catch((error) => {
            console.log("获取推荐税率错误");
          });
        this.contract
          .generations()
          .then((data) => {
            console.log("generations=", data);
            // this.contentData.total = data;
            this.$set(this.contentData, "generations", data);
          })
          .catch((error) => {
            console.log("");
          });
        this.contract
          .firstRate()
          .then((data) => {
            console.log("firstRate=", data);
            // this.contentData.total = data;
            this.$set(this.contentData, "firstRate", data);
          })
          .catch((error) => {
            console.log("获取firstRate错误");
          });
        this.contract
          .secondRate()
          .then((data) => {
            console.log("secondRate=", data);
            // this.contentData.total = data;
            this.$set(this.contentData, "secondRate", data);
          })
          .catch((error) => {
            console.log("获取secondRate错误");
          });
        this.contract
          .thirdRate()
          .then((data) => {
            console.log("thirdRate=", data);
            // this.contentData.total = data;
            this.$set(this.contentData, "thirdRate", data);
          })
          .catch((error) => {
            console.log("获取thirdRate错误");
          });

        this.contract
          .leftRate()
          .then((data) => {
            console.log("leftRate=", data);
            // this.contentData.total = data;
            this.$set(this.contentData, "leftRate", data);
          })
          .catch((error) => {
            console.log("获取leftRate错误");
          });
      }

      this.contract
        .rewardToken()
        .then((data) => {
          console.log("rewardToken=", data);
          this.$set(this.contentData, "rewardToken", data);
        })
        .catch((error) => {
          console.log("获取分红代币错误");
        });
      this.contract
        .enableChangeTax()
        .then((data) => {
          console.log("enableChangeTax=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "enableChangeTax", data);
        })
        .catch((error) => {
          console.log("enableChangeTax");
        });
      this.contract
        .enableRewardList()
        .then((data) => {
          console.log("enableRewardList=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "enableRewardList", data);
        })
        .catch((error) => {
          console.log("enableRewardList");
        });

      this.contract
        .enableOffTrade()
        .then((data) => {
          console.log("enableOffTrade=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "enableOffTrade", data);
        })
        .catch((error) => {
          console.log("enableOffTrade");
        });

      this.contract
        .removeLiquidityFee()
        .then((data) => {
          console.log("removeLiquidityFee=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "removeLiquidityFee", data);
        })
        .catch((error) => {
          console.log("获取撤池税率错误");
        });

      this.contract
        .enableKillBlock()
        .then((data) => {
          console.log("enableKillBlock=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "enableKillBlock", data);
        })
        .catch((error) => {
          console.log("获取杀抢跑区块错误");
        });
      this.contract
        .kb()
        .then((data) => {
          console.log("kb=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "kb", data);
        })
        .catch((error) => {
          console.log("获取杀抢跑区块错误");
        });
      if (this.template == "lpDividend") {
        this.contract
          .enableWalletLimit()
          .then((data) => {
            console.log("enableWalletLimit=", data);
            // this.contentData.total = data;
            this.$set(this.contentData, "enableWalletLimit", data);
          })
          .catch((error) => {
            console.log("enableWalletLimit error");
          });
        this.contract
          .maxWalletAmount()
          .then((data) => {
            console.log("maxWalletAmount=", data);
            // this.contentData.total = data;
            this.$set(this.contentData, "maxWalletAmount", data);
          })
          .catch((error) => {
            console.log("获取maxWalletAmount错误");
          });
      }

      this.contract
        .airdropEnable()
        .then((data) => {
          console.log("airdropEnable=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "airdropEnable", data);
        })
        .catch((error) => {
          console.log("获取airdropEnable错误");
        });
      this.contract
        .airdropNumbs()
        .then((data) => {
          console.log("airdropNumbs=", data);
          // this.contentData.total = data;
          this.$set(this.contentData, "airdropNumbs", data);
        })
        .catch((error) => {
          console.log("获取交易空头地址数错误");
        });
    },

    setFunction() {
       if (
        this.tokenDetailData.chainId != localStorage.getItem("TokenBox-chainID")
      ) {
        this.$message.warning("当前网络与合约发布记录不一致,建议您先切换网络");
        return;
      }
      console.log(this.dialogInfo, this.inputText);
      if (this.inputText.length == 0 && this.dialogInfo.tag != 41) {
        this.$message.warning("请输入内容！");
        return;
      }
      var tag = this.dialogInfo.tag;
      if (tag == 11) {
        this.transferOwnershipFunction(this.inputText);
      } else if (tag == 21) {
        //设置加持税率
        this.setAddLiquidityFee(this.inputText);
      } else if (tag == 22) {
        //设置撤持税率
        this.setRemoveLiquidityFee(this.inputText);
      } else if (tag == 31) {
        //修改持币上限
        this.changeWalletLimit(this.inputText);
      } else if (tag == 32) {
        //移除持币白名单
        this.setisMaxEatExempt(this.inputText, true);
      } else if (tag == 33) {
        //添加除持币黑名单
        this.setisMaxEatExempt(this.inputText, false);
      } else if (tag == 34) {
        //添加白名单
        this.multi_bclist(this.inputText, true);
      } else if (tag == 35) {
        //移除黑名单
        this.multi_bclist(this.inputText, false);
      } else if (tag == 36) {
        //杀开盘抢跑机器人
        this.setkb(this.inputText);
      } else if (tag == 37) {
        //设置空投数量
        this.setAirdropNumbs(this.inputText);
      } else if (tag == 38) {
        //添加交易对
        this.setSwapPairList(this.inputText, true);
      } else if (tag == 41) {
        //修改税率
        this.changeFee();
      } else if (tag == 42) {
        //添加税率白名单
        this.setFeeWhiteList(this.inputText, true);
      } else if (tag == 43) {
        //移除税率白名单
        this.setFeeWhiteList(this.inputText, false);
      } else if (tag == 44) {
        //修改营销钱包
        this.setFundAddress(this.inputText);
      } else if (tag == 51) {
        //提取合约内本币代币
        return;
        //没找到合约方法
      } else if (tag == 52) {
        //提取合约内分红代币
        return;
        //没找到合约方法
      } else if (tag == 53) {
        //设置分红黑名单
        this.setExcludeHolder(this.inputText, true);
      } else if (tag == 54) {
        //设置分红阈值
        this.setHolderRewardCondition(this.inputText);
      } else if (tag == 61) {
        //修改推荐税率
        this.tokenForm.inviterFee = this.inputText;
        this.completeCustoms();
      } else if (tag == 62) {
        //设置推荐奖励比例
        return;
        //没找到合约方法
      } else if (tag == 63) {
        //设置最小转账金额
        this.setMinTransAmount(this.inputText);
      }
    },
    changeFee() {
      this.tokenForm.buyResult =
        parseFloat(this.tokenForm.buyFundFee) +
        parseFloat(this.tokenForm.buyBurnFee) +
        parseFloat(this.tokenForm.buyRewardFee) +
        parseFloat(this.tokenForm.buyLPFee) +
        parseFloat(this.tokenForm.inviterFee);
      console.log("buyResult=", this.tokenForm.buyResult);
      if (this.tokenForm.buyResult > 25) {
        this.$message({
          message: "买入百分比设置,总比例不可以大于百分之25%",
          type: "warning",
        });
        return;
      }
      this.tokenForm.sellResult =
        parseFloat(this.tokenForm.sellFundFee) +
        parseFloat(this.tokenForm.sellBurnFee) +
        parseFloat(this.tokenForm.sellRewardFee) +
        parseFloat(this.tokenForm.sellLPFee) +
        parseFloat(this.tokenForm.inviterFee);
      if (this.tokenForm.sellResult > 25) {
        this.$message({
          message: "卖出百分比设置,总比例不可以大于百分之25%",
          type: "warning",
        });
        return;
      }
      this.completeCustoms();
    },
    async transferOwnershipFunction(value) {
      if (!this.$isAddress(value)) {
        this.$message.warning("输入地址不合法");
        return;
      }
      try {
        var tx = await this.contract.transferOwnership(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("transferOwnership=", res);
        this.$message.success("所有权转让成功");
        this.contentData.owner = value;
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async renounceOwnership() {
       if (
        this.tokenDetailData.chainId != localStorage.getItem("TokenBox-chainID")
      ) {
        this.$message.warning("当前网络与合约发布记录不一致,建议您先切换网络");
        return;
      }
      try {
        var tx = await this.contract.renounceOwnership();
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("transferOwnership=", res);
        this.$message.success("丢弃权限成功");
        this.contentData.owner = "";
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async changeInviteRate(value) {
      try {
        var tx = await this.contract.changeInviteRate(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("transferOwnership=", res);
        this.$message.success("修改推荐税率成功");
        this.contentData.inviterFee = value;
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setAddLiquidityFee(value) {
      if (value > 25) {
        this.$message.warning("税率不能超过25%");
        return;
      }
      try {
        var tx = await this.contract.setAddLiquidityFee(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setAddLiquidityFee=", res, tx);
        this.$message.success("设置加池税率成功");
        this.contentData.addLiquidityFee = value;
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setRemoveLiquidityFee(value) {
      if (value > 100) {
        this.$message.warning("税率不能超过100%");
        return;
      }
      try {
        var tx = await this.contract.setRemoveLiquidityFee(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("transferOwnership=", res, tx);
        this.$message.success("修改撤池税率成功");
        this.contentData.removeLiquidityFee = value;
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async startLP(value) {
      try {
        var tx = await this.contract.startLP(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("transferOwnership=", res);
        this.$message.success("开启交易成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async changeWalletLimit(value) {
      const regex = /^[0-9]*$/;
      if (!regex.test(value)) {
        this.$message.warning("请输入合法数值");
        return;
      }
      try {
        var tx = await this.contract.changeWalletLimit(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("transferOwnership=", res);
        this.$message.success("修改持币上线成功");
        this.contentData.maxWalletAmount = value;
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async disableWalletLimit() {
       if (
        this.tokenDetailData.chainId != localStorage.getItem("TokenBox-chainID")
      ) {
        this.$message.warning("当前网络与合约发布记录不一致,建议您先切换网络");
        return;
      }
      try {
        var tx = await this.contract.disableWalletLimit();
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("transferOwnership=", res);
        this.$message.success("关闭持币限制成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setisMaxEatExempt(value, boolValue) {
      if (!this.$isAddress(value)) {
        this.$message.warning("输入地址不合法");
        return;
      }
      try {
        var tx = await this.contract.setisMaxEatExempt(value, boolValue);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setisMaxEatExempt=", res);
        this.$message.success("设置持币白名单成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async multi_bclist(value, boolValue) {
      if (!this.$isAddress(value)) {
        this.$message.warning("输入地址不合法");
        return;
      }
      try {
        var tx = await this.contract.multi_bclist([value], boolValue);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("multi_bclist=", res);
        this.$message.success("设置黑名单成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setkb(value) {
      const regex = /^[0-9]*$/;
      if (!regex.test(value)) {
        this.$message.warning("请输入合法数值");
        return;
      }
      try {
        var tx = await this.contract.setkb(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setkb=", res);
        this.$message.success("设置成功");
        this.contentData.kb = value;
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setAirdropNumbs(value) {
      const regex = /^[0-9]*$/;
      if (!regex.test(value)) {
        this.$message.warning("请输入合法数值");
        return;
      }
      if (value > 5) {
        this.$message.warning("最大空投数量为5");
        return;
      }
      try {
        var tx = await this.contract.setAirdropNumbs(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setAirdropNumbs=", res);
        this.$message.success("设置空投数量成功");
        this.contentData.airdropNumbs = value;
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setSwapPairList(value, boolValue) {
      if (!this.$isAddress(value)) {
        this.$message.warning("输入地址不合法");
        return;
      }
      try {
        var tx = await this.contract.setSwapPairList(value, boolValue);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setSwapPairList=", res);
        this.$message.success("添加交易对成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async completeCustoms() {
      //未完成
      try {
        var arr = [
          this.tokenForm.buyFundFee * 100,
          this.tokenForm.buyLPFee * 100,
          this.tokenForm.buyRewardFee * 100,
          this.tokenForm.buyBurnFee * 100,
          this.tokenForm.sellFundFee * 100,
          this.tokenForm.sellLPFee * 100,
          this.tokenForm.sellRewardFee * 100,
          this.tokenForm.sellBurnFee * 100,
        ];
        if (this.template == "lpWithInviter") {
          arr[8] = this.tokenForm.inviterFee * 100;
        }
        var tx = await this.contract.completeCustoms(arr);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("completeCustoms=", res);
        this.$message.success("设置税率成功");
        this.contentData.buyFundFee = this.tokenForm.buyFundFee;
        this.contentData.buyLPFee = this.tokenForm.buyLPFee;
        this.contentData.buyBurnFee = this.tokenForm.buyFundFee;
        this.contentData.buyRewardFee = this.tokenForm.buyRewardFee;
        this.contentData.sellFundFee = this.tokenForm.sellFundFee;
        this.contentData.sellLPFee = this.tokenForm.sellLPFee;
        this.contentData.sellRewardFee = this.tokenForm.sellRewardFee;
        this.contentData.sellBurnFee = this.tokenForm.sellBurnFee;
        if (this.template == "lpWithInviter") {
          this.contentData.inviterFee = this.tokenForm.inviterFee;
        }
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setFeeWhiteList(value, boolValue) {
      if (!this.$isAddress(value)) {
        this.$message.warning("输入地址不合法");
        return;
      }
      try {
        var tx = await this.contract.setFeeWhiteList([value], boolValue);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setFeeWhiteList=", res);
        this.$message.success("设置税率白名单成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setFundAddress(value) {
      if (!this.$isAddress(value)) {
        this.$message.warning("输入地址不合法");
        return;
      }
      try {
        var tx = await this.contract.setFundAddress(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setFundAddress=", res);
        this.$message.success("设置营销地址成功");
        this.contentData.fundAddress = value;
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setExcludeHolder(value, boolValue) {
      if (!this.$isAddress(value)) {
        this.$message.warning("输入地址不合法");
        return;
      }
      try {
        var tx = await this.contract.setExcludeHolder(value, boolValue);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setExcludeHolder=", res);
        this.$message.success("设置分红黑名单成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setHolderRewardCondition(value) {
      try {
        var tx = await this.contract.setHolderRewardCondition(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setHolderRewardCondition=", res);
        this.$message.success("设置分红阈值成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },
    async setMinTransAmount(value) {
      try {
        var tx = await this.contract.setMinTransAmount(value);
        this.$message.success("已提交，等待区块确认");
        const res = await tx.wait();
        console.log("setMinTransAmount=", res);
        this.$message.success("设置最小转账金额成功");
      } catch (error) {
        this.$showErrorMessage(error);
      }
    },

    onlyNumber() {
      this.tokenForm.buyFundFee = this.onlyNumOnePoint(
        this.tokenForm.buyFundFee
      );
      this.tokenForm.buyBurnFee = this.onlyNumOnePoint(
        this.tokenForm.buyBurnFee
      );
      this.tokenForm.buyRewardFee = this.onlyNumOnePoint(
        this.tokenForm.buyRewardFee
      );
      this.tokenForm.buyLPFee = this.onlyNumOnePoint(this.tokenForm.buyLPFee);

      this.tokenForm.sellFundFee = this.onlyNumOnePoint(
        this.tokenForm.sellFundFee
      );
      this.tokenForm.sellBurnFee = this.onlyNumOnePoint(
        this.tokenForm.sellBurnFee
      );
      this.tokenForm.sellRewardFee = this.onlyNumOnePoint(
        this.tokenForm.sellRewardFee
      );
      this.tokenForm.sellLPFee = this.onlyNumOnePoint(this.tokenForm.sellLPFee);
      console.log(this.tokenForm);
    },
    onlyNumOnePoint(number_only) {
      if (number_only == null) {
        return null;
      }
      console.log("onlyNumOnePoint=", number_only);
      //先把非数字的都替换掉，除了数字和小数点
      number_only = number_only.replace(/[^\d.]/g, "");
      //必须保证第一个为数字而不是小数点
      number_only = number_only.replace(/^\./g, "");
      //保证只有出现一个小数点而没有多个小数点
      number_only = number_only.replace(/\.{2,}/g, ".");
      //保证小数点只出现一次，而不能出现两次以上
      number_only = number_only
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".");
      //保证只能输入两个小数
      number_only = number_only.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
      return number_only;
    },

    //setExcludeHolder黑名单 setSwapPairList 添加交易对  setMinTransAmount feeWhiteList  setProcessRewardWaitBlock
  },
  computed: {
    buyTaxRate() {
      var buyFundFee = isNaN(parseFloat(this.contentData.buyFundFee))
        ? 0
        : parseFloat(this.contentData.buyFundFee);
      var buyBurnFee = isNaN(parseFloat(this.contentData.buyBurnFee))
        ? 0
        : parseFloat(this.contentData.buyBurnFee);

      var buyRewardFee = isNaN(parseFloat(this.contentData.buyRewardFee))
        ? 0
        : parseFloat(this.contentData.buyRewardFee);

      var buyLPFee = isNaN(parseFloat(this.contentData.buyLPFee))
        ? 0
        : parseFloat(this.contentData.buyLPFee);
      var inviterFee = isNaN(parseFloat(this.contentData.inviterFee))
        ? 0
        : parseFloat(this.contentData.inviterFee);
      this.contentData.buyResult =
        buyFundFee + buyBurnFee + buyRewardFee + buyLPFee + inviterFee;
      return this.contentData.buyResult;
    },
    sellTaxRate() {
      var sellFundFee = isNaN(parseFloat(this.contentData.sellFundFee))
        ? 0
        : parseFloat(this.contentData.sellFundFee);
      var sellBurnFee = isNaN(parseFloat(this.contentData.sellBurnFee))
        ? 0
        : parseFloat(this.contentData.sellBurnFee);

      var sellRewardFee = isNaN(parseFloat(this.contentData.sellRewardFee))
        ? 0
        : parseFloat(this.contentData.sellRewardFee);

      var sellLPFee = isNaN(parseFloat(this.contentData.sellLPFee))
        ? 0
        : parseFloat(this.contentData.sellLPFee);
      var inviterFee = isNaN(parseFloat(this.contentData.inviterFee))
        ? 0
        : parseFloat(this.contentData.inviterFee);
      this.contentData.sellResult =
        sellFundFee + sellBurnFee + sellRewardFee + sellLPFee + inviterFee;
      return this.contentData.sellResult;
    },
  },
};
</script>

<style lang="scss" scoped>
.token-body {
  width: calc(100% - 16%);
  height: 100%;
  background: #1f1f1f;
  border-radius: 20px 20px 20px 20px;

  padding: 0px 8%;

  .token-table {
    width: 100%;
    height: 100%;

    .table-title {
      font-weight: normal;
      font-size: 20px;
      color: #8f8f8f;
      line-height: 23px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      margin: 20px 0 0 0;
    }

    .table-body {
      width: 100%;
      height: auto;
      margin: 40px 0 0 0;
      display: flex;

      .table-left {
        width: 100%;
        min-width: 700px;
        height: auto;
        margin: 0 10px 0 0;
        flex: 3;

        .basicInfo {
          width: 100%;
          height: auto;
          background: #292929;
          border-radius: 8px 8px 8px 8px;
          margin: 0 0 20px 0;
        }

        .economicModel {
          width: 100%;
          height: auto;
          min-height: 30vh;
          background: #292929;
          border-radius: 8px 8px 8px 8px;
        }

        .basicInfo-title {
          width: calc(100% - 24px);
          height: 36px;
          font-weight: normal;
          font-size: 16px;
          color: #bcbcbc;
          line-height: 36px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          border-bottom: 1px solid #616161;
          padding: 5px 12px;
        }

        .basicInfo-content {
          width: 100%;
          height: auto;

          padding: 12px 0px;

          .content {
            width: 100%;
            height: auto;
            background: rgba(77, 77, 77, 0.5);
            display: flex;
            align-items: center;

            .label {
              flex: 1;
              flex-grow: 1;
              width: 100%;
              width: 15%;
              min-width: 150px;
              height: 36px;
              background: rgba(77, 77, 77, 0.5);
              font-weight: normal;
              font-size: 14px;
              color: #d8d8d8;
              line-height: 36px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              padding: 0 12px 0 12px;
              background: transparent;
            }

            .text {
              flex: 1;
              width: 100%;
              min-width: 150px;
              height: 36px;
              font-weight: normal;
              font-size: 14px;
              color: #d8d8d8;
              line-height: 36px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              padding: 0 12px 0 12px;
              background: #292929;
            }

            .label2 {
              width: 15%;
              min-width: 150px;
              height: 40px;
              font-weight: normal;
              font-size: 14px;
              color: #d8d8d8;
              line-height: 40px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              padding: 0 12px 0 12px;
            }

            .text2 {
              // flex: 3;
              flex-grow: 1;
              width: 100%;
              min-height: 20px;
              font-weight: normal;
              font-size: 14px;
              color: #d8d8d8;
              line-height: 20px;
              text-align: left;
              font-style: normal;
              text-transform: none;
              padding: 10px 12px;
              background: #292929;
            }
          }
        }
      }

      .table-right {
        width: 100%;
        height: auto;
        margin: 0 0 0 10px;

        flex: 1;

        .permissionControl {
          width: 100%;
          height: auto;
          background: #292929;
          border-radius: 8px 8px 8px 8px;
          margin: 0 0 20px 0;
        }

        .liquidityControl {
          width: 100%;
          height: auto;
          background: #292929;
          border-radius: 8px 8px 8px 8px;
          margin: 0 0 20px 0;
        }

        .transactionControl {
          width: 100%;
          height: auto;
          background: #292929;
          border-radius: 8px 8px 8px 8px;
          margin: 0 0 20px 0;
        }

        .taxRateControl {
          width: 100%;
          height: auto;
          background: #292929;
          border-radius: 8px 8px 8px 8px;
          margin: 0 0 20px 0;
        }

        .dividendControl {
          width: 100%;
          height: auto;
          background: #292929;
          border-radius: 8px 8px 8px 8px;
          margin: 0 0 20px 0;
        }

        .basicInfo-title {
          width: calc(100% - 24px);
          height: 36px;
          font-weight: normal;
          font-size: 16px;
          color: #bcbcbc;
          line-height: 36px;
          text-align: center;
          font-style: normal;
          text-transform: none;
          border-bottom: 1px solid #616161;
          padding: 5px 12px;
        }

        .basicInfo-content {
          width: 100%;
          height: auto;

          padding: 12px 0px 12px 0px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .btn {
            width: auto;
            height: 30px;
            // background: #4438d4;
            // border-radius: 30px 30px 30px 30px;
            // border: 1px solid #5d52d6;

            font-weight: normal;
            font-size: 12px;
            // color: #ffffff;
            line-height: 30px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            white-space: nowrap;
            padding: 0 15px 0 15px;

            margin: 6px;
            cursor: pointer;
          }

          .btn:hover {
            border: 1px solid #aba4ff;
          }
        }
      }
    }
  }

  .el-icon-document-copy {
    margin: 0 0 0 12px;
    cursor: pointer;
  }
}
/deep/.el-input {
  margin-bottom: 10px;
}
/deep/.el-dialog__body {
  //  min-height: 00px;
  align-content: center;
}
/deep/.el-input__inner::placeholder,
.el-textarea__inner::placeholder {
  color: #b8b6b6 !important;
}
</style>